

export class net {

  public offline: boolean = false;

  static serverUrl = net.getServerUrl();
  static gamedataFolder: string = net.getGameDataFolder()
  // static adminFolder: string = ''

  static getServerUrl(){
    //return (document.body.dataset.server === '{{server_url}}') ? 'http://localhost:8200' : String(document.body.dataset.server)
    return (document.body.dataset.server === '{{$server_url}}') ? 'http://'+window.location.hostname+':8200' : String(document.body.dataset.server)
  }

  static getGameDataFolder(){
    return (document.body.dataset.gamedata === '{{$gamedata}}') ? '/screens/' : String(document.body.dataset.gamedata)
  }

  static getAdminFolder(){
    return (document.body.dataset.folder === '{{$folder}}') ? '' : String(document.body.dataset.folder)
  }
  
  // fetch json
  static fetchJson(url:string, data:any, cb:Function ){
    console.log('NET:',net.serverUrl +  url)    
    fetch(net.serverUrl +  url).then( resp=>{
      resp.json().then( data=>{
        cb(data);
      })
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  // post data
  static sendJson(type:string, url: string, data:any, cb:Function){

    var opt = {
      method: type,
      headers: {
        "Content-Type": "application/json",
      },      
      body: JSON.stringify(data)
    }

    fetch(net.serverUrl+url,opt).then( resp=>{
      resp.json().then( data=>{
        cb(data)
      })
    })


    // console.log('SEND JSON:', url);
    // var xobj = new XMLHttpRequest();
    // xobj.overrideMimeType("application/json");

    // try {
    //   xobj.open( type, net.serverUrl + url, true); // Replace 'my_data' with the path to your file    
    //   xobj.onreadystatechange = function () {
    //         if (xobj.readyState === 4 && String(xobj.status) === "200") {
    //           // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
    //           cb(  JSON.parse(xobj.responseText) )
    //           //callback(xobj.responseText);
    //         }
    //   };
    //   xobj.send( JSON.stringify(data));    
    // }catch (e){
    //   console.warn(e)
    //   cb({})
    // }

    return
  }


  /**
   * Parse the passed variables from the URL
   * 
   * @memberof dataLoader
   */
   static urlVariables = (varkey?:string) => {
    let res:any = {};
    if (document.location.toString().indexOf('?') !== -1) {
      var query = document.location
        .toString()
        // get the query string
        .replace(/^.*?\?/, '')
        // and remove any existing hash string (thanks, @vrijdenker)
        .replace(/#.*$/, '')
        .split('&');

      for (var i = 0, l = query.length; i < l; i++) {
        var aux = decodeURIComponent(query[i]).split('=');
        var key = aux[0].toLowerCase();
        res[key] = aux[1];
      }
    }
    return varkey ? res[varkey] : res
  }


}



